import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        signedIn: false,
        showLoginModal: false,
        showSignUpModal: false,
        showFeedbackModal: false,
        showManualModal: false,
        showWatchMovieModal: false,
        credits: 0,
        apiUrl: 'https://z07ttgtiob.execute-api.eu-central-1.amazonaws.com/api/',
        movie_url: 'https://s3.eu-central-1.amazonaws.com/traffic-movies/817f3164-138d-47b0-b9d5-6263dcdecf46/817f3164-138d-47b0-b9d5-6263dcdecf46.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA34XAAGS6DLBFSD7L%2F20200228%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T212037Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBUaDGV1LWNlbnRyYWwtMSJHMEUCIQCbxWsqV8UTAgPAkKAA4XP69MAtoIH5tdDJ%2BxB%2BUedXOAIgUsYnsp0Rfw0pwn%2FRQRPAVyKz3Ya4HeEl7yJLF3Yv9vAq9gEI3v%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARADGgw4MTc1ODczMDM2MTIiDOFC0VyJLgo5zdoOlyrKAcA5p99j4mw7I5XualiJuYnPZlNpDQGD6OnHMNoeLXkOvzZR4Zgp%2FD14%2F%2FXgZh8xAvehTOWIYfSmrSz40swWY77f6bxMHWAE%2BV%2BtqpBpiMyziNVh7C9IiAs0lQR7s2OKe%2FNA8zf%2FMggibfsjAhvud71cP0tLrVPFjem5ya5HgLQ09CHyHrchgxmnLMou2e06sG%2FkvqhyBt3pMCK0TYUNlXzTFCXKidcYgXLf0gBRER6cHymTyaO8fGM%2F3thj8JexX4ZZz%2BlwUASERbUw7YHm8gU64AGL71djD62RIZX7S68ULlrDsnFJLPMBrAfI8Lrh528thwcRTMmjuwgOMaB5gmD9O%2FFL%2BTQWGYhTA6Fc9rXYvb4o1S7XBQ%2BgFnw5yZ3QArpXhOa%2BGBImLKnHFUTQ24ubtGahuGsqhIWQCzuZRc%2FWvnvUSF7%2BMKfHKorb2R6xW6l07eYB%2FlzAAkRIHgeX6JgQAWyd0ob66ZicdtWn243Dift8sTOFtoNWBN6NjFB1CHKCVRa6lBq9Q0PbKVeYVxviQ1pc5Bz1DMy%2F5rvH5mnmDwQqjIEFgamkeaSsgaSvaL8HTg%3D%3D&X-Amz-Signature=c82ae09644569c59a303a3cab1ff1ab3e88d9d2747e80c9cabab9f6423180bc0',
        socket: {
            isConnected: false,
            message: null,
            reconnectError: false,
        }
    },

    mutations:{
        SOCKET_ONOPEN (state, event)  {
            Vue.prototype.$socket = event.currentTarget
            state.socket.isConnected = true
            console.log('websocket geopend')
        },
        SOCKET_ONCLOSE (state, event)  {
            state.socket.isConnected = false
            console.log('websocket gesloten')
        },
        SOCKET_ONERROR (state, event)  {
            state.socket.isConnected = false
            console.error('socket error')
        },
        // default handler called for all methods
        SOCKET_ONMESSAGE (state, message)  {
            state.socket.message = message
        },
        // mutations for reconnect methods
        SOCKET_RECONNECT(state, count) {
            state.socket.isConnected = true
            console.info(state, count)
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.isConnected = false
            state.socket.reconnectError = true;
        },
        toggleLoginModal(state) {
            state.showLoginModal = !state.showLoginModal
        },
        toggleSignUpModal(state) {
            state.showSignUpModal = !state.showSignUpModal
        },
        toggleFeedbackModal(state) {
            state.showFeedbackModal = !state.showFeedbackModal
        },
        toggleManualModal(state) {
            state.showManualModal = !state.showManualModal
        },
        toggleWatchMovieModal(state) {
            state.showWatchMovieModal = !state.showWatchMovieModal
        }
    },

    getters: {
        showLoginModal: state => {
            return state.showLoginModal
        },
        showSignUpModal: state => {
            return state.showSignUpModal
        },
        showFeedbackModal: state => {
            return state.showFeedbackModal
        },
        showManualModal: state => {
            return state.showManualModal
        },
        showWatchMovieModal: state => {
            return state.showWatchMovieModal
        },
        showEmail: state => {
            if (state.user == null) {
                return null
            } else {
                return state.user.attributes.email
            }
        },
        showName: state => {
            if (state.user == null) {
                return null
            } else {
                return state.user.attributes.name
            }
        },
        showOrganization: state => {
            if (state.user == null) {
                return null
            }
            else {
                return state.user.attributes['custom:organization']
            }
        },
        showAdminPanel: state => {
            if (state.user == null) {
                return false
            }
            else if (state.user.signInUserSession.accessToken.payload.hasOwnProperty('cognito:groups')) {
                if (state.user.signInUserSession.accessToken.payload['cognito:groups'].includes('admin')) {
                    return true
                } else {
                    return false
                }
            }
            else {
                return false
            }
        }
    },

    actions: {
    },

    modules: {
    }
})
